import { render } from "./px-list-modal.vue?vue&type=template&id=6d218d18&ts=true"
import script from "./px-list-modal.vue?vue&type=script&lang=ts"
export * from "./px-list-modal.vue?vue&type=script&lang=ts"

import "./px-list-modal.vue?vue&type=style&index=0&id=6d218d18&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__